import styled from '@emotion/styled';

const AppWrapper = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
});

export default AppWrapper;
